import { render } from "./HomeGame.vue?vue&type=template&id=a2cd1cee&scoped=true"
import script from "./HomeGame.vue?vue&type=script&lang=js"
export * from "./HomeGame.vue?vue&type=script&lang=js"

import "./HomeGame.vue?vue&type=style&index=0&id=a2cd1cee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2cd1cee"]])

export default __exports__